import { apiService } from './index';
import {
    IRegisterAnswer,
    IRegisterQuestions,
    IRegisterSurvey,
    IRegisterSurveyResponse,
} from '../shared/types/survey';

export const asyncGetSurveys = async (page?: number, pageSize?: number) => {
    return await apiService.get('/api/survey', {
        limit: pageSize || '',
        page: page || '',
    });
};

export const asyncPostSurvey = async (formSurvey: IRegisterSurvey) => {
    return await apiService.post('/api/survey', formSurvey);
};

export const asyncGetSurvey = async (
    id: string | undefined,
    active?: boolean | undefined
) => {
    return await apiService.get(
        `/api/survey/${id}`,
        active ? { active } : undefined
    );
};

export const asyncPatchSurvey = async (id: string, formSurvey: any) => {
    return await apiService.put(`/api/survey/${id}`, formSurvey);
};

export const asyncDeleteSurvey = async (id: string) => {
    return await apiService.delete(`/api/survey/${id}`);
};

export const asyncGetQuestions = async (
    page?: number,
    pageSize?: number,
    survey?: string,
    showAnswers?: boolean
) => {
    return await apiService.get('/api/question', {
        limit: pageSize || '',
        page: page || '',
        survey: survey || '',
        showAnswers: showAnswers || '',
    });
};

export const asyncPostQuestion = async (formQuestions: IRegisterQuestions) => {
    return await apiService.post('/api/question', formQuestions);
};

export const asyncUpdatePositions = async (survey: string, items: string[]) => {
    return await apiService.put('/api/question', { survey, items });
};

export const asyncUpdatePositionsAnwers = async (
    question: string,
    items: string[]
) => {
    return await apiService.put('/api/answer', { question, items });
};

export const asyncDeleteQuestion = async (id: string, idSurvey: string) => {
    return await apiService.delete(`/api/question/${id}/${idSurvey}`);
};

export const asyncGetQuestion = async (id: string | undefined) => {
    return await apiService.get(`/api/question/${id}`);
};

export const asyncPatchQuestion = async (
    id: string,
    formQuestions: IRegisterQuestions
) => {
    return await apiService.put(`/api/question/${id}`, formQuestions);
};

export const asyncPostAnswer = async (formAnswer: IRegisterAnswer) => {
    return await apiService.post('/api/answer', formAnswer);
};

export const asyncGetAnswersByQuestion = async (
    question: string | undefined,
    page?: number,
    pageSize?: number,
    status?: boolean
) => {
    return await apiService.get('/api/answer', {
        question,
        limit: pageSize || '',
        page: page || '',
        status,
    });
};

export const asyncPatchAnswer = async (
    id: string | undefined,
    formAnswer: IRegisterAnswer
) => {
    return await apiService.put(`/api/answer/${id}`, formAnswer);
};

export const asyncDeleteAnswer = async (
    id: string | undefined,
    idQuestion: string | undefined,
    idSurvey: string | undefined
) => {
    return await apiService.delete(
        `/api/answer/${id}/${idQuestion}/${idSurvey}`
    );
};

export const asyncPostSurveyResponse = async (
    formSurveyResponse: IRegisterSurveyResponse
) => {
    return await apiService.post('/api/survey/response', formSurveyResponse);
};

export const asyncGetQuestionDependency = async () => {
    return await apiService.get('/api/question/questionDependency');
};
